export const ButtonVariant = {
  Primary: 'primary',
  Secondary: 'secondary',
  Ghost: 'ghost',
} as const

export type ButtonVariant = (typeof ButtonVariant)[keyof typeof ButtonVariant]
